<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header modal-title-extra">
    Are You There?
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <h3 class="inactive-title">Inactive Session</h3>
    <p style="text-align:center;">You have been inactive for some time. Please re-login to continue.</p>
  </div>
  <div class="modal-footer" style="justify-content: center;">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default col-2 col-offset-5" (click)="logOut()">
      Ok
    </button>
  </div>
</div>
